import React, { useEffect, useState } from "react";
import { adminApi } from "../utils/axiosConfig";
import { FaBox, FaShoppingCart, FaEuroSign, FaStar } from "react-icons/fa";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function Statistiques() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await adminApi.get(`/api/admin/stats`);

        if (!response.data.success) {
          throw new Error(response.data.message || "Erreur inconnue");
        }

        setStats(response.data);
      } catch (err) {
        console.error("Erreur de chargement des stats :", err);
        setError("Impossible de charger les statistiques.");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading)
    return (
      <p style={{ padding: "2rem", textAlign: "center" }}>Chargement...</p>
    );
  if (error)
    return (
      <p style={{ padding: "2rem", color: "red", textAlign: "center" }}>
        {error}
      </p>
    );

  return (
    <div
      style={{
        maxWidth: 1250,
        margin: "0 auto",
        padding: "2rem 1rem",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Cartes de stats */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "1.5rem",
        }}
      >
        <StatCard
          icon={<FaBox />}
          label="Produits"
          value={stats.totalProducts}
          color="#4f46e5"
        />
        <StatCard
          icon={<FaShoppingCart />}
          label="Commandes"
          value={stats.totalOrders}
          color="#10b981"
        />
        <StatCard
          icon={<FaEuroSign />}
          label="Revenus"
          value={`${stats.revenue.toFixed(2)} DH`}
          color="#f59e0b"
        />
        <StatCard
          icon={<FaStar />}
          label="Populaires"
          value={stats.popularProducts.length}
          color="#ef4444"
        />
      </div>

      {/* Graphique des ventes */}
      <div style={{ marginTop: "3rem" }}>
        <h2
          style={{
            fontSize: "1.25rem",
            fontWeight: "600",
            marginBottom: "1rem",
            textAlign: "center",
          }}
        >
          Ventes mensuelles
        </h2>
        <div
          style={{
            background: "white",
            padding: "1rem",
            borderRadius: "8px",
            boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
            height: "300px",
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={stats.monthlySales}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="revenue"
                stroke="#6366f1"
                strokeWidth={2}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

function StatCard({ icon, label, value, color }) {
  return (
    <div
      style={{
        background: "white",
        padding: "1rem",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
      }}
    >
      <div
        style={{
          background: color,
          color: "white",
          borderRadius: "50%",
          padding: "0.75rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.25rem",
          minWidth: "45px",
          minHeight: "45px",
        }}
      >
        {icon}
      </div>
      <div>
        <p style={{ margin: 0, fontSize: "0.9rem", color: "#6b7280" }}>
          {label}
        </p>
        <h3 style={{ margin: 0, fontSize: "1.25rem", fontWeight: "700" }}>
          {value}
        </h3>
      </div>
    </div>
  );
}
